var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DropDown } from "../../ui/drop.down";
import { EventHandler } from "../../interaction/eventhandler";
var DropDownComponent = /** @class */ (function () {
    function DropDownComponent(options) {
        var _a;
        this.options = __assign({ enabled: true }, options);
        this.options.onChange = EventHandler.Create(this.options.onChange);
        if (this.options.bindTo != null && this.options.property != null && this.options.value == null) {
            this.options.value = (((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toUI) ?
                this.options.converter.toUI(this.options.bindTo[this.options.property]) :
                this.options.bindTo[this.options.property]);
        }
    }
    DropDownComponent.prototype.render = function () {
        return {
            tag: "select"
        };
    };
    DropDownComponent.prototype.getRef = function () {
        return this.ref;
    };
    DropDownComponent.prototype.onCreate = function (node) {
        var _this = this;
        this.ref = DropDown(node.dom, this.options);
        if (!this.options.enabled) {
            this.ref.disable();
        }
        node.dom.parentElement.classList.add(this.options.class);
        if (this.options.width) {
            node.dom.parentElement.style.display = "inline-block";
        }
        node.dom.addEventListener("change", function (evt) {
            var _a;
            var value;
            if (_this.options.multiple) {
                value = Array.prototype.slice.call(node.dom.querySelectorAll("option:checked"), 0).map(function (v) { return v.value; });
            }
            else {
                value = node.dom.value;
            }
            if (_this.options.bindTo != null && _this.options.property != null) {
                _this.options.bindTo[_this.options.property] =
                    ((_a = _this.options.converter) === null || _a === void 0 ? void 0 : _a.toData) ? _this.options.converter.toData(value) : value;
            }
            if (_this.options.onSelect != null) {
                _this.options.onSelect(value);
            }
            if (_this.options.onChange != null) {
                _this.options.onChange.notify(value);
            }
        });
        if (this.options.value != null) {
            this.ref.setValue(this.options.value);
        }
    };
    DropDownComponent.prototype.onRemove = function () {
        if (this.ref != null) {
            this.ref.destroy();
        }
    };
    return DropDownComponent;
}());
export { DropDownComponent };
